import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api, errorText } from "../lib/api";

export const LoginGate = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await api.post("/auth/admin/login", { password });
      onSuccess(r.data);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-page p-6" data-testid="admin-login-gate">
      <form onSubmit={submit} className="panel w-full max-w-sm p-8 fade-up">
        <div className="flex items-center gap-3 mb-6">
          <span className="inline-flex items-center bg-coal rounded-lg px-2.5 py-1.5">
            <img src="/fora-logo.png" alt="FORA" className="h-5 w-auto" draggable={false} />
          </span>
          <div>
            <h1 className="font-bold text-xl leading-tight text-ink">Clients Live</h1>
            <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5">
              <ShieldCheck className="w-3 h-3" /> Admin access
            </p>
          </div>
        </div>
        <label className="eyebrow block mb-2" htmlFor="admin-password">
          Admin password
        </label>
        <input
          id="admin-password"
          data-testid="admin-login-input"
          type="password"
          autoFocus
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-lg bg-slate-50 border border-slate-300 px-4 py-3 text-base text-ink outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition"
          placeholder="••••••••"
        />
        {error && (
          <p data-testid="login-error" className="mt-3 text-sm text-brand">
            {error}
          </p>
        )}
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={busy || !password}
          className="mt-6 w-full rounded-lg bg-brand hover:bg-[#c42320] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-3 transition-colors shadow-sm"
        >
          {busy ? "Checking…" : "Open admin"}
        </button>
      </form>
    </div>
  );
};
